<template>
    <div class="leftnav">
        <el-menu class="el-menu-vertical-demo" @select="check" background-color="#545c64" text-color="#fff"
            active-text-color="#18C3B1" default-active="index">
            <el-menu-item index="index" v-if="accountutil.checkPermission('index')">
                <i class="iconfont icon-shouye1 mr10 f18"></i>
                <span>首页</span>
            </el-menu-item>
            <el-submenu index="2">
                <template slot="title" v-if="accountutil.checkPermission('customer')" >
                    <i class="iconfont icon-kehu mr10 f18"></i>
                    <span>客户管理</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item index="agent" v-if="accountutil.checkPermission('customer_agent')" >
                        <i class="iconfont icon-jingxiaoshang mr10 f18"></i>
                        <span>经销商</span>
                    </el-menu-item>
                    <el-menu-item index="group" v-if="accountutil.checkPermission('customer_group')" >
                        <i class="iconfont icon-1jituan mr10 f18"></i>
                        <span>集团客户</span>
                    </el-menu-item>
                    <el-menu-item index="shop" v-if="accountutil.checkPermission('customer_store')" >
                        <i class="iconfont icon-permissions mr10 f18"></i>
                        <span>门店客户</span>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="screen" v-if="accountutil.checkPermission('guidscreen')" >
                <i class="iconfont icon-screen mr10 f18"></i>
                <span>屏幕管理</span>
            </el-menu-item>
            <el-menu-item index="application" v-if="accountutil.checkPermission('app')">
                <i class="iconfont icon-app mr10 f18"></i>
                <span>APP管理</span>
            </el-menu-item>
        </el-menu>
        <div @click="loginout" class="out">
            退出
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        mounted(){
            var that = this;
            var navHeight = document.querySelector('.leftnav');
            var height = document.documentElement.clientHeight;
            var width = document.documentElement.clientWidth;
            navHeight.style.height = (height - 50) + 'px';
        },
        methods: {
            check(index){
                var that = this;
                that.$emit('setPage',index);
            },
            loginout() {
                var that = this;
                that.httputil.post({
                    url: that.api.logout,
                    req:{},
                    xmsuccess:function(){
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        that.$root.eventHub.$emit('backlogin', false)
                    },
                });
            },
        }
    }
</script>

<style scoped>
    .el-menu{
        border-right:none;
    }
    .leftnav{
        width: 202px;
        position: absolute;
        background: #545c64;
        height: 800px;
        top:50px;
        left:0;
        z-index: 3;
    }
    .out{
        position: absolute;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #666;
        color: #fff;
        bottom:20px;
        left:0;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/navLeft.vue